import { ProductImage } from '@/core/components'
import React from 'react'
import { useSuspenseFragment } from 'react-relay-offline'
import { graphql } from 'babel-plugin-relay/macro'
import { csx } from '@vtex/admin-ui'

import type { ProducSkuImageDesktopProps_ProductSku$data } from './__generated__/ProducSkuImageDesktopProps_ProductSku.graphql'
import { ShowSkuImagesGalleryButton } from './ShowSkuImagesGalleryButton'
import { SKU_THUMBNAILS_ITEMS_LIMIT } from '../constants'
import type { ProductSkuThumbnails_ProductSkuImageConnection$key } from './__generated__/ProductSkuThumbnails_ProductSkuImageConnection.graphql'

const productSkuImageConnectionFragment = graphql`
  fragment ProductSkuThumbnails_ProductSkuImageConnection on ProductSkuImageConnection {
    edges {
      node {
        id
        urlThumbnail: url(size: 420)
      }
    }
    ...ShowSkuImagesGalleryButton_ProductSkuImageConnection
  }
`

export type ProductSkuThumbnailsProps = {
  productSkuImageConnectionRef: ProductSkuThumbnails_ProductSkuImageConnection$key
  activeSkuImage: ProducSkuImageDesktopProps_ProductSku$data['images']['edges'][number]
  onThumbnailClick: (skuImageId: string) => void
  onShowSkuImagesGalleryClick: () => void
}

export const ProductSkuThumbnails = ({
  productSkuImageConnectionRef,
  activeSkuImage,
  onThumbnailClick,
  onShowSkuImagesGalleryClick,
}: ProductSkuThumbnailsProps) => {
  const productSkuImageConnection = useSuspenseFragment(
    productSkuImageConnectionFragment,
    productSkuImageConnectionRef
  )

  const slicedSkuThumbnails = productSkuImageConnection.edges.slice(
    0,
    SKU_THUMBNAILS_ITEMS_LIMIT
  )

  return (
    <div
      className={csx({
        display: 'grid',
        gap: '$space-3',
        alignContent: 'flex-start',
      })}
    >
      {slicedSkuThumbnails.map((skuImage) => (
        <ProductImage
          key={skuImage.node.id}
          src={skuImage.node.urlThumbnail}
          alt=""
          className={csx({
            cursor: 'pointer',
            ...(activeSkuImage.node.id === skuImage.node.id
              ? {
                  border: '$mainSelected',
                  borderRadius: '4px',
                }
              : null),
          })}
          onClick={() => onThumbnailClick(skuImage.node.id)}
        />
      ))}
      <ShowSkuImagesGalleryButton
        productSkuImageConnectionRef={productSkuImageConnection}
        onClick={onShowSkuImagesGalleryClick}
      />
    </div>
  )
}
